module.exports = {
  "PUBLIC_ANDROID_APP_ID": "com.whillo",
  "PUBLIC_API_DOMAIN_NAME": "api.whillo.com",
  "PUBLIC_API_DOMAIN_NAME_WEB": "api.treefortsystems.com",
  "PUBLIC_API_ENDPOINT": "",
  "PUBLIC_APPLE_ID": "1619970447",
  "PUBLIC_APP_ID": "316",
  "PUBLIC_APP_NAME": "Whillo",
  "PUBLIC_AUTH_DOMAIN_NAME": "auth.treefortsystems.com",
  "PUBLIC_AUTH_ENDPOINT": "https://app.whillo.com",
  "PUBLIC_CDN_ENDPOINT": "https://cdn2.treefortsystems.com",
  "PUBLIC_CLIENT_ID_WEB": "01e20138-ec3e-4e09-b3b3-8f66e0d6dc4e",
  "PUBLIC_DEBUG": "",
  "PUBLIC_DOMAIN_NAME": "app.whillo.com",
  "PUBLIC_EAS_PROJECT_ID": "713ac9a1-615c-4a21-ab3f-97c760c3feca",
  "PUBLIC_EAS_UPDATE_CHANNEL": "prd_whillo",
  "PUBLIC_ENV": "production",
  "PUBLIC_FIREBASE_CONFIG_WEB": "eyJhcHBJZCI6IjE6NDg0ODIwNjI3MjYxOndlYjoyOTkxNjYxMWQ5YTZmOWJjODc5ZjU0IiwiYXBpS2V5IjoiQUl6YVN5Qk5abkNGWVFTRTF4Q1I3dk5mZ1FOU1lKQkFWNTM1YVRVIiwicHJvamVjdElkIjoid2hpbGxvLWQ3ZTlmIiwiYXV0aERvbWFpbiI6IndoaWxsby1kN2U5Zi5maXJlYmFzZWFwcC5jb20iLCJsb2NhdGlvbklkIjoidXMtY2VudHJhbCIsIm1lYXN1cmVtZW50SWQiOiJHLUJRWkM5TERQOVAiLCJzdG9yYWdlQnVja2V0Ijoid2hpbGxvLWQ3ZTlmLmFwcHNwb3QuY29tIiwibWVzc2FnaW5nU2VuZGVySWQiOiI0ODQ4MjA2MjcyNjEifQ==",
  "PUBLIC_FIREBASE_MESSAGING_VAPID_PUBLIC_KEY": "BPpC8q0BkG4CwpjGfAEY78pNHWaVZoLJi8dYqVcs2ZGKDZ7RR8huBq95DTpw31CwTGhu8v6gdk7SdMnCoO2MqSQ",
  "PUBLIC_GOOGLE_SITE_VERIFICATION_TOKEN": "",
  "PUBLIC_ICON_BACKGROUND_COLOR": "#ffffff",
  "PUBLIC_ICON_FOREGROUND_IMAGE_PADDING": "44",
  "PUBLIC_ICON_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/e5224f47-eb5e-4092-888c-27e9af64cb0e/uploads/f24d7a68-3baf-4ea8-8f5f-7f6d22c94f70.png",
  "PUBLIC_IOS_BUNDLE_ID": "com.whillo",
  "PUBLIC_MANIFEST_URL": "",
  "PUBLIC_META_PIXEL_ID": "408847791318295",
  "PUBLIC_OBJECT_STORAGE_CDN_ENDPOINT": "https://cdn.treefortsystems.com/file/treefort-ott-prod",
  "PUBLIC_PASSWORDLESS": "disabled",
  "PUBLIC_REGION_ENDPOINT": "https://media.treefortsystems.com/region",
  "PUBLIC_RUDDERSTACK_WRITE_KEY_WEB": "2ktaIKUnEb0tbITGLbbLB0ZhQNu",
  "PUBLIC_SENTRY_DSN_WEB": "https://2a13400a30ad4037a8f0cf127af14bff@o1003299.ingest.sentry.io/5966172",
  "PUBLIC_SENTRY_ENABLE_EVENTS": "true",
  "PUBLIC_SENTRY_PROFILES_SAMPLE_RATE": "0.5",
  "PUBLIC_SENTRY_TRACES_SAMPLE_RATE": "0.005",
  "PUBLIC_SINGULAR_APP_ID_WEB": "",
  "PUBLIC_SINGULAR_SDK_KEY": "",
  "PUBLIC_SINGULAR_SDK_SECRET": "",
  "PUBLIC_SPLASH_BACKGROUND_COLOR": "",
  "PUBLIC_SPLASH_LOGO_URL": "",
  "PUBLIC_SPLASH_LOGO_WIDTH": "",
  "PUBLIC_SPLASH_SCREEN_BACKGROUND_COLOR": "#ffffff",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/e5224f47-eb5e-4092-888c-27e9af64cb0e/uploads/1d9a694a-eba6-4d69-bd7b-066b41c69fbf.png",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_WIDTH": "156",
  "PUBLIC_TENANT_ID": "e5224f47-eb5e-4092-888c-27e9af64cb0e",
  "PUBLIC_MAJOR_VERSION": "32",
  "PUBLIC_MINOR_VERSION": "11",
  "PUBLIC_PATCH_VERSION": "4",
  "PUBLIC_SENTRY_DIST": "v0",
  "PUBLIC_SENTRY_RELEASE_WEB": "app.whillo.com@32.11.4",
  "PUBLIC_SPLASH_SCREEN_DISPLAY_MODE": "light"
}
